import { Injectable } from '@angular/core';
import { IFaq } from '@shared/interfaces';

@Injectable({
    providedIn: 'root'
})
export class AdminFaqService {
    currentItem: IFaq;
    historyStack: IFaq[] = [];

    selectItem(item: IFaq) {
        if (!this.historyStack.some(e => e.id === this.currentItem.id)) {
            if (item.items || !item.content) {
                this.historyStack.push(this.currentItem);
                this.currentItem = item;
            }
        }
    }

    goBack(): IFaq {
        return (this.currentItem = this.historyStack.pop());
    }

    replaceHistory(val: IFaq[]) {
        const history = [];
        for (const item of this.historyStack) {
            history.push(item.id ? this.getItem(val, item.id) : { items: val });
        }
        this.historyStack = history;

        if (!this.historyStack?.length) {
            this.currentItem = { items: val };
        }
    }

    getItem(items: IFaq[], id: string): IFaq {
        let result: IFaq;
        if (items) {
            for (const item of items) {
                if (item.id === id) {
                    result = item;
                } else if (item.items) {
                    result = this.getItem(item.items, id);
                }
                if (result) {
                    break;
                }
            }
        }
        return result;
    }
}
